function addToCartGlobal(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      ometria.trackAddToBasket(data.product_id, 1);
      refreshCart();
      // Optionally, update the cart count or show a success message
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
}


function calcLeftMargin(section) {
  let sectionHeader = document.querySelector(`.logo-inner`);

  let style = getComputedStyle(sectionHeader);
  let itemLeftmargin = style.marginLeft;

  document.documentElement.style.setProperty('--section-margin', itemLeftmargin);
}

function refreshCart() {
  const cartItemsSection = document.querySelector('.cart-items');
  const shippingSection = document.querySelector('#shipping-thresh');
  let cartTotals = document.querySelectorAll('.cart-total');
  let cartCounts = document.querySelectorAll('.cart-count');
  let cartLoyaltyPoints = document.querySelector('.cart-loyalty__points-value span');

  fetch("/cart?view=jscart")
    .then(response => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;

      const cartItems = html.querySelector('.cart-items');
      const shippingSectionUpdated = html.querySelector('#shipping-thresh');
      const cartTotal = html.querySelector('#cart-total').innerText;
      const countText = html.querySelector('#cart-count').innerText;
      const pointsText = html.querySelector('.cart-loyalty__points-value span').innerText;

      console.log(pointsText)

      if (cartItems.innerHTML.trim().length) {
        shippingSection.innerHTML = shippingSectionUpdated.innerHTML;
        cartItemsSection.innerHTML = cartItems.innerHTML;

        cartLoyaltyPoints.innerHTML = pointsText;
        
        cartTotals.forEach((cartTotalSing) => {
          cartTotalSing.innerText = cartTotal;
        })
        
        cartCounts.forEach((cartCount) => {
          cartCount.innerText = countText;
        })
      }
      const scriptElement = html.querySelector('#ometria-basket');

      if (scriptElement) {
        // Remove any existing script with the same id to prevent duplicates
        const existingScript = document.getElementById('ometria-basket');
        if (existingScript) {
          existingScript.remove();
        }

        // Create a new script element and set its content
        const script = document.createElement('script');
        script.id = 'ometria-basket';
        script.type = 'text/javascript';
        script.innerHTML = scriptElement.innerHTML;

        // Append the new script to the document body
        document.body.appendChild(script);
      }
      // console.log('Yes lad')
    });
}


function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => {
      refreshCart();
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
    });
}

function updateItem(variantId, newQuantity, productHandle) {
  beforeCartRequest();
  if (productHandle) {
    // First fetch the cart so we can gather gift items.
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const updates = {};
        // Update the main product.
        updates[variantId] = newQuantity;
        
        // Find gift items that match the main product handle.
        const giftItems = cart.items.filter((item) =>
          item.properties &&
          (item.properties._offerFreeProduct === `free-for-${productHandle}` ||
           item.properties._hiddenFree === `free-for-${productHandle}`)
        );
        console.log("check gift items", giftItems);
        
        if (giftItems.length > 0) {
          // Update gift items based on their type
          for (let i = 0; i < giftItems.length; i++) {
            const item = giftItems[i];
            
            // Check if this is a _hiddenFree item with _hiddenFreeQuantity
            if (item.properties._hiddenFree === `free-for-${productHandle}` && 
                item.properties._hiddenFreeQuantity) {
              // Multiply newQuantity by _hiddenFreeQuantity for hidden free items
              const multiplier = parseInt(item.properties._hiddenFreeQuantity) || 1;
              updates[item.key] = newQuantity * multiplier;
            } else {
              // For regular gift items, use newQuantity as is
              updates[item.key] = newQuantity;
            }
          }
        }
       
        
        // Make one combined update call.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
      })
      .then((response) => response.json())
      .then((data) => {
        console.log('Cart updated with merged gift:', data);
        refreshCart();
      })
      .catch((error) => console.error('Error updating cart:', error))
      .finally(afterCartRequest);
  } else {
    // Fallback: simple update if productHandle is not provided.
    const updates = { [variantId]: newQuantity };
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then((response) => response.json())
      .then((data) => {
        refreshCart();
      })
      .catch((error) => console.error('Error updating main product:', error))
      .finally(afterCartRequest);
  }
}

function triggerChangeEvent(element) {
  // Create and dispatch a new 'change' event
  const event = new Event('change', { bubbles: true });
  element.dispatchEvent(event);
}

function updateAdjacentValue(element, change) {
  let input = element.parentElement.querySelector('input');
  
  // Ensure the input's value is treated as a number
  let currentValue = parseInt(input.value) || 0;
  
  // Update the value
  input.value = currentValue + change;

  triggerChangeEvent(input);
  
}

function deleteItem(variantId, productHandle) {
  // Remove the specified item from the cart
  console.log(productHandle);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Item removed. Updated cart data:', data);

      // Refresh cart after initial item removal
      refreshCart();

      // Check for items with '_offerFreeProduct' property
      removeItemsWithProperty(
        data.items,
        '_offerFreeProduct', 
        `free-for-${productHandle}`,
        () => {
          // Refresh cart after removing '_offerFreeProduct' items

          // After that, check for items with '_hiddenFree' property
          fetch('/cart.js')
            .then((response) => response.json())
            .then((updatedData) => {
              removeItemsWithProperty(
                updatedData.items,
                '_hiddenFree',
                `free-for-${productHandle}`,
                () => {
                  // Refresh cart after removing '_hiddenFree' items
                  refreshCart();
                }
              );
            })
            .catch((error) => {
              console.error('Error fetching updated cart data:', error);
            })
            .finally(afterCartRequest);
        }
      );
    })
    .catch((error) => {
      console.error('Error removing item from cart:', error);
    })
    .finally(afterCartRequest);
}

// Helper function to remove items with a specific property using /cart/update.js
function removeItemsWithProperty(items, propertyName, propertyValue, callback) {
  console.log(propertyName);
  console.log(propertyValue);
  console.log(items);

  const itemsToRemove = items.filter(
    (item) =>
      item.properties && item.properties[propertyName] === propertyValue
  );

  if (itemsToRemove.length > 0) {
    const updates = {};

    itemsToRemove.forEach((item) => {
      updates[item.key] = 0; // Set quantity to 0 to remove the item
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: updates,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(`Removed items with property ${propertyName}:`, data);
        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch((error) => {
        console.error(
          `Error removing items with property ${propertyName}:`,
          error
        );
      })
      .finally(afterCartRequest);
  } else {
    if (typeof callback === 'function') {
      callback();
    }
  }
}


/******************************************************************
 *  BUSY-HANDLING HELPERS
 ******************************************************************/
let activeCartRequests = 0;

/* Turn every relevant button on / off  */
function setCartControlsEnabled(enabled) {
  document
    .querySelectorAll(
      '.cart-item__single button,' +          // + / – / remove
      '.quick-add_button,' +                  // collection quick-add
      '[data-mobile-add],' +                  // mobile quick-add toggle
      '.cart-icon'                            // header cart icon
    )
    .forEach(btn => {
      if (enabled) {
        btn.removeAttribute('disabled');
        btn.classList.remove('btn--disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('btn--disabled');
      }
    });
}

/* Call before every AJAX cart hit */
function beforeCartRequest() {
  if (activeCartRequests === 0) setCartControlsEnabled(false);
  activeCartRequests++;
}

/* Call in .finally() of every AJAX cart hit */
function afterCartRequest() {
  activeCartRequests = Math.max(0, activeCartRequests - 1);
  if (activeCartRequests === 0) setCartControlsEnabled(true);
}


function toggleCartDrawer() {
  document.querySelector('#cart-drawer__container').classList.toggle('cart-drawer-open');
  document.querySelector('body').classList.toggle('cart-drawer-is-open');
  setTimeout(refreshCart, 1000);
}

// Select the button
const backToTopButton = document.querySelector('.back-to-top');

// Function to scroll to top
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// Function to toggle button visibility
function toggleButtonVisibility() {
  if (window.scrollY > 300) {
    backToTopButton.style.display = 'block';
  } else {
    backToTopButton.style.display = 'none';
  }
}



document.addEventListener("DOMContentLoaded", () => {
  // Add click event listener to the button
  backToTopButton.addEventListener('click', scrollToTop);

  // Add scroll event listener to the window
  window.addEventListener('scroll', toggleButtonVisibility);

  // Initial call to set button visibility
  toggleButtonVisibility();
  if (window.animations == true) {
    AOS.init();
  };

  document.querySelector('.cart-icon').addEventListener('click', toggleCartDrawer);
  if (document.querySelector('[data-cs-click]')) {
    document.querySelector('[data-cs-click]').addEventListener('click', function (e) {
      e.preventDefault();
      toggleCartDrawer();
    });
  }

  if (document.querySelector('#cart-close')) {
    document.querySelector('#cart-close').addEventListener('click', toggleCartDrawer);
  }

  // Function to handle quick add button clicks
  function handleQuickAdd(event) {
    const quickAddButton = event.target.closest('.quick-add_button');
    if (quickAddButton) {
      let variantId = quickAddButton.getAttribute('data-add');
      addToCartGlobal(variantId);

      if (window.location.pathname != '/cart') {
        toggleCartDrawer();
      }
    }
  }

  // Function to handle mobile quick add button clicks
  function handleMobileQuickAdd(event) {
    const mobileQuickAddButton = event.target.closest('[data-mobile-add]');
    if (mobileQuickAddButton) {
      // Search for the .quick-add__popup element by traversing up the DOM
      let currentElement = mobileQuickAddButton;
      let popup = null;
      while (currentElement && !popup) {
        popup = currentElement.querySelector('.quick-add__popup');
        currentElement = currentElement.parentElement;
      }

      if (popup) {
        popup.classList.toggle('opacity-100');
      } else {
        console.error('Could not find .quick-add__popup element');
      }
    }
  }

  // Attach event listeners to the document
  document.addEventListener('click', handleQuickAdd);
  document.addEventListener('click', handleMobileQuickAdd);

  setTimeout(calcLeftMargin, 250);

  class HorizontalScrollDragger {
    constructor(element) {
      this.slider = typeof element === 'string' ? document.querySelector(element) : element;
      if (!this.slider) {
        console.error('HorizontalScrollDragger: Element not found');
        return;
      }
  
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;
      this.dragThreshold = 5;
  
      this.init();
    }
  
    init() {
      this.slider.style.cursor = 'grab';
      this.slider.addEventListener('mousedown', this.handleMouseDown.bind(this));
      window.addEventListener('mousemove', this.handleMouseMove.bind(this));
      window.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.slider.addEventListener('click', this.handleClick.bind(this), true);
    }
  
    handleMouseDown(e) {

      if (e.target.closest('select')) {
        return; // Allow default behavior for select elements
      }

      this.isDown = true;
      this.slider.style.cursor = 'grabbing';
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
      this.hasDragged = false;
      e.preventDefault(); // Prevent text selection
      
    }
  
    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX);
      this.slider.scrollLeft = this.scrollLeft - walk;
      
      if (Math.abs(walk) > this.dragThreshold) {
        this.hasDragged = true;
      }
    }
  
    handleMouseUp(e) {
      if (!this.isDown) return;
      this.isDown = false;
      this.slider.style.cursor = 'grab';
      if (this.hasDragged) {
        e.preventDefault();
      }
    }
  
    handleClick(e) {
      if (this.hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        this.hasDragged = false;
      }
    }
  }
  
  document.querySelectorAll('.overflow-x-scroll').forEach(slider => {
    new HorizontalScrollDragger(slider);
  });

  let sliderButtons = document.querySelectorAll('.slider-nav__button');
  sliderButtons.forEach((sliderButton, index) => {
    sliderButton.addEventListener('click', () => {
      let slider = sliderButton.closest('section').querySelector('.overflow-x-scroll.active');
      let direction = sliderButton.dataset.direction;
      let scrollPercentage = 0.8; // 80% scroll
      let scrollAmount = slider.offsetWidth * scrollPercentage;
      let currentScroll = slider.scrollLeft;

      if (direction == 'next') {
        let maxScroll = slider.scrollWidth - slider.offsetWidth;
        slider.scrollTo({
          left: Math.min(currentScroll + scrollAmount, maxScroll),
          behavior: 'smooth'
        });
      } else {
        slider.scrollTo({
          left: Math.max(currentScroll - scrollAmount, 0),
          behavior: 'smooth'
        });
      }
    });
  });

});

window.addEventListener('resize', calcLeftMargin);

document.addEventListener('DOMContentLoaded', function () {

  /*
   * Lazy load background images
   */
  window.initLazyLoading = function() {
    const lazyBgElements = document.querySelectorAll('.lazy-bg[data-bg-src]');
    
    // Add a rootMargin of 20px so elements are loaded slightly before they enter view
    const lazyBgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const bgImageUrl = element.getAttribute('data-bg-src');

          element.style.backgroundImage = bgImageUrl;
          element.removeAttribute('data-bg-src');
          observer.unobserve(element);
        }
      });
    }, { rootMargin: '20px' });

    lazyBgElements.forEach(element => {
      lazyBgObserver.observe(element);
    });


    /*
     * Lazy load <img> tags
     */
    const lazyImgElements = document.querySelectorAll('.lazy-img[data-src]');

    // Similarly, use a rootMargin of 20px for images
    const lazyImgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');

          img.src = src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '20px' });

    lazyImgElements.forEach(img => {
      lazyImgObserver.observe(img);
    });
  };

  // Call the function to initialize lazy loading
  window.initLazyLoading();
});



 